// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"28a94f0ec569287f","965":"8708b0354d7451ed"}[chunkId] + ".css";
};